import { Fab } from "@mui/material";
import { PostAdd } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { modal } from "../../features/modal/modalSlice";

const ButtonAdd = ({ title = 'Agregar' }) => {
    const dispatch = useDispatch();

    return(
        <Fab variant="extended" color="success"  onClick={() => dispatch(modal())}>
            <PostAdd sx={{ mr: 1 }} />
            { title }
        </Fab>
    )
}

export default ButtonAdd;